export default __webpack_public_path__ + "static/media/resumeIcon.54863e75.svg";